import {DriveLayout, KilnShellLayout, StationLayout} from '@domain/kiln-monitoring'

export type BuildDriveLocationsInput = Pick<DriveLayout, 'id' | 'position'>
export type BuildStationLocationsInput = Pick<StationLayout, 'id' | 'thrustRollerPosition'>
export type BuildKilnShellLocationsInput = Pick<KilnShellLayout, 'id'>

export enum PinionParts {
  BEARING_LEFT = 'bearing-left',
  BEARING_RIGHT = 'bearing-right',
  PINION = 'pinion'
}

export enum OpenDriveParts {
  GIRTH_GEAR = 'girth-gear',
  DRIVE_TOP = 'top',
  DRIVE_BOTTOM = 'bottom'
}

export enum DriveParts {
  MOTOR = 'motor',
  GEARBOX = 'gearbox',
  PINION = 'pinion'
}

export enum KilnShellParts {
  KILN_SHELL = 'shell'
}

export type KilnShellPartType = {
  width: number
  distanceFrom0: number
  y: number
  height: number
  type: 'cone' | 'tube'
  prevY?: number
  startHeight?: number
  endHeight?: number
}
